var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"followers"},[_c('li',_vm._l((_vm.ids),function(follower){return _c('person-name',{key:follower,attrs:{"tag":"li","sid":follower}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }